<div class="flex flex-col gap-3">
  @switch (mode()) {
    @case (TimeReportingType.MANUAL) {
      <div class="flex flex-col items-center gap-1">
        <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-duration' | translate }}</span>
        <proffeo-ui-time-picker
          [maxHour]="99"
          [minuteStep]="minuteStep()"
          [formField]="manualTime()"
          label="time-reports-form-modal-duration"
        />
      </div>

      <proffeo-time-buttons (timeSelected)="onQuickTimeSelected($event)"></proffeo-time-buttons>

      @if (showManualDurationError()) {
        <mat-error class="text-sm w-full text-right">
          {{ 'ui-forms-time-duration-is-required' | translate }}
        </mat-error>
      }
    }

    @case (TimeReportingType.RANGE) {
      @if (timeRange(); as range) {
        <div class="flex flex-col gap-3">
          <div class="flex flex-col items-center gap-1">
            <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-duration' | translate }}</span>
            <div
              [attr.aria-label]="durationDisplay()"
              class="flex items-center gap-3"
            >
              <span class="flex h-10 w-14 items-center justify-center rounded-md border border-proffeo-border">
                {{ durationHoursDisplay() }}
              </span>
              <span class="proffeo-ui-text-muted">:</span>
              <span class="flex h-10 w-14 items-center justify-center rounded-md border border-proffeo-border">
                {{ durationMinutesDisplay() }}
              </span>
            </div>
          </div>

          <div class="grid grid-cols-2 items-start gap-4">
            <div class="flex flex-col items-center gap-1">
              <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-from' | translate }}</span>
              <proffeo-ui-time-picker
                (timeUpdated)="onFirstTimePickerUpdated()"
                [minuteStep]="minuteStep()"
                [formField]="range.from"
                label="time-reports-form-modal-from"
              />
            </div>

            <div class="flex flex-col items-center gap-1">
              <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-to' | translate }}</span>
              <proffeo-ui-time-picker
                #secondTimePicker
                [minuteStep]="minuteStep()"
                [formField]="range.to"
                label="time-reports-form-modal-to"
              />
            </div>
          </div>
        </div>

        @if (showTimeRangeError()) {
          <mat-error class="text-sm text-right">
            {{ 'time-reports-form-modal-the-time-range-is-not-valid' | translate }}
          </mat-error>
        }
      }
    }

    @case (TimeReportingType.TIMER) {
      <!-- handled in modal, not in form -->
    }
  }

  <ng-content select="[after-time-fields]" />
</div>
